// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {updateCustomer} from '../../shared/repositories';

export const updateCustomerDetails = entityId =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return updateCustomer(entityId)
            .then(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data: entityId,
                    type: actions.UPDATE_CUSTOMER_DETAILS_SUCCESS
                });

                successAlertBar('CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY');

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };



// WEBPACK FOOTER //
// ./src/customer/details/action-creators/update-customer.js